<template>
  <div class="menu-item-wrap">
    <template v-if="!(menu.meta && menu.meta.showChildren)">
      <AppLink :to="resolvePath(menu.path)">
        <el-menu-item :index="resolvePath(menu.path)" v-if="!isCollapse" class="custom-icon">
          <i :class="[menu.meta.icon]"></i>
          <span class="submemu-icon " v-if="!menu.meta.isHome"></span>
          <span class="menu-text">{{ menu.meta.title }}</span>
        </el-menu-item>
        <el-tooltip v-else class="item" effect="dark" :content="menu.meta.title" placement="left">
          <el-menu-item :index="resolvePath(menu.path)">
            <i :class="[menu.meta.icon]"></i>
          </el-menu-item>
        </el-tooltip>
      </AppLink>
    </template>

    <el-submenu :index="resolvePath(menu.path)" popper-append-to-body v-else>
      <template slot="title">
        <i :class="[menu.meta.icon]"></i>
        <span v-if="!isCollapse">{{ menu.meta.title }}</span>
      </template>
      <template v-if="menu.children">
        <SubMenuItem
          v-for="child in filterMemuChild"
          :key="child.path"
          :menu="child"
          :is-nest="true"
          :base-path="resolvePath(menu.path)"
          :isCollapse="false"
        />
      </template>
    </el-submenu>
  </div>
</template>

<script>
import {isExternal} from '@/utils/validate'
import path from 'path'
import AppLink from './Link'
export default {
  name: 'SubMenuItem',
  components: {
    AppLink
  },
  props: {
    menu: {
      type: [Array, Object],
      default() {
        return []
      }
    },
    isCollapse: {
      type: Boolean,
      default() {
        return false
      }
    },
    isNest: {
      type: Boolean,
      default() {
        return false
      }
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  methods: {
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  },
  computed: {
    filterMemuChild() {
      const child = this.menu.children
      return child.filter(d => !d.meta.hidden)
    }
  }
}
</script>
<style lang="scss" scoped>
// .custom-icon {
//   position: relative;
//   .submemu-icon {
//     position: absolute;
//     left: 24px;
//     top: 50%;
//     width: 8px;
//     border-bottom: 1px solid #ffffffb3;
//   }
// }
// .el-menu-item.is-active .submemu-icon {
//   width: 20px;
//   left: 18px;
//   border-color: #00A791;
//   transition: 1s all cubic-bezier(.46, 1, .23, 1.52);
// }
// .menu-text {
//   margin-left: 10px;
// }
// .el-menu--vertical {
//   .submemu-icon {
//     display: none;
//   }
// }
</style>
